module.exports = __webpack_public_path__ + "static/media/4_Kate_N@3x.d9112cb6.jpg";